import { useState, useCallback } from "react";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import type { DevToolsPlugin } from "../../types";

function getJourneyId(): string {
  return window.location.pathname.split("/").pop() || "";
}

function constructJaegerUrl(journeyId: string): string {
  const tags = JSON.stringify({ "journey.id": journeyId });
  return `http://localhost:16686/search?&service=chopin&tags=${encodeURIComponent(tags)}`;
}

function TracesPanel() {
  const [downloading, setDownloading] = useState(false);
  const journeyId = getJourneyId();

  const handleViewInJaeger = useCallback(() => {
    window.open(constructJaegerUrl(journeyId), "_blank");
  }, [journeyId]);

  const handleDownload = useCallback(async () => {
    setDownloading(true);
    try {
      const link = document.createElement("a");
      link.href = `/dev_tools/traces/${journeyId}/download`;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading traces:", error);
    } finally {
      setDownloading(false);
    }
  }, [journeyId]);

  return (
    <>
      <div className="dt-traces__description">
        View distributed traces for the current journey via Jaeger.
      </div>

      <div className="dt-section-label">Journey ID</div>
      <div className="dt-traces__journey-id">
        <span className="dt-mono">{journeyId || "none"}</span>
      </div>

      <div className="dt-traces__actions">
        <button
          className="dt-btn dt-btn--primary"
          onClick={handleViewInJaeger}
          disabled={!journeyId}
          type="button"
        >
          View in Jaeger
        </button>
        <button
          className="dt-btn"
          onClick={handleDownload}
          disabled={!journeyId || downloading}
          type="button"
        >
          {downloading ? "Downloading..." : "Download JSON"}
        </button>
      </div>
    </>
  );
}

export function tracesPlugin(): DevToolsPlugin {
  return {
    id: "traces",
    name: "Traces",
    icon: faMagnifyingGlass,
    render: () => <TracesPanel />,
  };
}
